import * as React from 'react';
import { Flex } from '../../Flex';
import { Button } from '@/hen-ui/atomics/Button';
import { Image } from '@/hen-ui/atomics/Image';
import type { ComparisonItem } from '../types';

export const ComparisonItemImage: React.FC<{ item: ComparisonItem }> = ({
  item,
}) => {
  return (
    <Flex
      className='relative w-28 h-16 bg-white border border-neutral-200 rounded-xs p-2'
      direction='column'
      align='center'
      justify='center'
    >
      <Image
        src={item.header.image.src}
        alt={item.header.image.alt}
        objectFit='contain'
        className='w-full h-full'
      />
      {item.header.remove && (
        <Button
          type='button'
          aria-label={item.header.remove.ariaLabel ?? 'Remove item'}
          onClick={item.header.remove.onClick}
          variant='iconOnly'
          size='sm'
          iconBefore={item.header.remove.icon ?? 'x'}
          className='absolute -right-xxs -top-xxs h-5 w-5 rounded-full bg-white text-heading shadow-xs focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2 lg:-right-xs lg:-top-xs'
        />
      )}
    </Flex>
  );
};

ComparisonItemImage.displayName = 'ComparisonItemImage';
